import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
/**
 * 获取状态下拉列表，防水报单：
 * @param {*} params
 * @param {*} params.type 订单类型water_proof_declaration是防水订单状态、ceil_declaration是吊顶订单状态、engineering 是工单阶段状态状态
 * @returns {*} 
 */
export const getOrderStatusList = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/status_enum/list?` + params,
    method: 'GET',
  })
}
export const getAgentList = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/agent`,
    method: "GET",
  });
};
// 获取面积电器配置
export const getAreaConfig = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/area_config/getConfigByDeclarationId?declarationId=${data.declarationId}&declarationFlag=${data.declarationFlag}`,
    method: "GET",
  });
};
// 获取面积电器配置
export const getEngineerAreaConfig = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/area_details`,
    method: "GET",
    params: data,
  });
};

// 费用单列表
export const findCustomsDeclaration = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/app_customs_declaration/costDetails/` + params,
    method: "GET",
  });
};
//getDeliveryOrder
export const getDeliveryOrder = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/infoV3?id=` + params,
    method: "GET",
  }); 
}
// 生成验收单
export const createAcceptanceOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/order`,
    method: "POST",
    data: data,
  });
};
// updateAcceptanceOrder
export const updateAcceptanceOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/update`,
    method: "PUT",
    data: data,
  });
};
//退回原因
export const passOrRefused = (data) => {
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
      method: 'PUT',
      data: data
  })
}
// passOrRefusedAcceptance
export const passOrRefusedAcceptance = (data) => {
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/update`,
      method: 'PUT',
      data: data
  })
}
export const getDownloadCode = (params) => {
  return request({
    url: `${baseUrl}/joins-product/v1/app_product/downloadMiniProgramCodeImageV2`,
    method: "POST",
    responseType: "blob",
    data: params,
  });
};
// 获取代理商Id
export const getRootDepartmentId = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/department/getRootDepartmentId`,
    method: "GET",
  });
};
export const findCeiling = (params) => {
  params = parseParam(params);
  params = params + "&type=HANG_CEILING";
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/ListV2?` + params,
    // url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration?` + params,
    method: "GET",
  });
};
export const getMerchantOrder = (params) => {
  return request({
    // url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration?id=` + params,
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/ListV2?id=` + params,
    method: "GET",
  });
};
export const getAreaConfigById = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/area_config/` + params,
    method: "GET",
  });
}
export const getGoodList = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/goodList/` + params,
    method: "GET",
  });
}

export const editMerchantOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration`,
    method: "PUT",
    data: data,
  });
};
export const downloadExcelCustomsDeclaration = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelHangCeiling?type=HANG_CEILING&`+ params,
    method: "GET",
    responseType: "blob",
  });
};
// downloadFinanceExcelCeiling
export const downloadFinanceExcelCeiling = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelHangCeilingFinance?type=HANG_CEILING&` + params,
    method: "GET",
    responseType: "blob",
  });
};
// downloadExcelHangCeilingDelivery - 交付吊顶Excel下载
export const downloadExcelHangCeilingDelivery = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelHangCeilingDelivery?type=HANG_CEILING&` + params,
    method: "GET",
    responseType: "blob",
  });
};
export const downloadExcelActualArea = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelAreaConfig?type=HANG_CEILING&` + params,
    method: "GET",
    responseType: "blob",
  });
};
export const findCeilingAll = () => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/choose/agent`,
    method: "GET",
  });
};

export const addCeiling = (data) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent`,
    method: "POST",
    data: data,
  });
};

export const editCeiling = (data) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent`,
    method: "PUT",
    data: data,
  });
};

export const delCeiling = (ids) => {
  let temp = ids.join(",");
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent/${temp}`,
    method: "DELETE",
  });
};
export const chooseSecondCeiling = (id) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/choose?superiorId=${id}`,
    method: "GET",
  });
};
export const handleRebates = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/audit/${data}`,
    method: "PUT",
  });
};
// 新增提货单
export const addDeliveryOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "POST",
    data: data,
  });
};
export const updateDeliveryOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "PUT",
    data: data,
  });
};
//内勤人员点击下一步/joins-sales-cloud/v1/customs_declaration/step
export const putNextStep = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/step`,
    method: "PUT",
    data: data,
  });
};

// 费用计算
export const calculateCost = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/calculateCost/${id}`,
    method: "GET",
  });
};

// 吊顶报单反审核接口
export const reverseReviewCeiling = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/reverseReview`,
    method: "PUT",
    data: { id },
  });
};

// 吊顶报单作废接口
export const cancelCeiling = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/manage_project_order/cancelled?declarationId=${params.declarationId}`,
    method: "POST",
    data: params,
  });
};